import React from 'react';
import { Helmet } from 'react-helmet';

import { TranslatedI18n } from '../types';
import { useI18n } from '../hooks';

const withHelmet = (path?: Exclude<keyof TranslatedI18n['helmet'], 'site-title'> | null) => {
	return function <P>(Component: React.ComponentType<P>) {

		const HelmetComponent: React.FC<P> = props => {
			const helmet = useI18n(i18n => i18n.helmet);

			return (
				<div className="routes">
					{path !== null ? ((path !== undefined && helmet[path]) ? (
						<Helmet>
							<meta name='description' content={helmet[path].description} />
							<meta property='og:title' content={helmet['site-title'] + ' | ' + helmet[path].title} />
							<meta property='og:type' content='website' />
							<title>{helmet['site-title'] + ' | ' + helmet[path].title}</title>
						</Helmet>
					) : (
						<Helmet>
							<meta property='og:title' content={helmet['site-title']} />
							<meta property='og:type' content='website' />
							<title>{helmet['site-title']}</title>
						</Helmet>
					)) : (
						<Helmet>
							<meta name="robots" content="noindex,nofollow" />
						</Helmet>
					)}
					<Component {...props} />
				</div>
			);
		}

		return HelmetComponent;
	}
}

export default withHelmet;